import { PlatformService } from '@lentau/ui-kit/core/services/platform/platform.service';
import {
  ApiGatewayClientPostfixV1,
  ApiGatewaySSRPostfixV1,
  ApiGatewayClientPostfixV2,
  ApiGatewaySSRPostfixV2,
} from './const';
import { ConfigHelper } from '@lentau/ssr/shared/configs/config.helper';

export const ApiGatewayBasePath: (window: Window, platformService: PlatformService) => string = (
  window: Window,
  platformService: PlatformService
) => {
  if (platformService.isBrowser) {
    return `${window.location.origin}/${ApiGatewayClientPostfixV1}`;
  }

  return `${ConfigHelper.getApiGatewayURLForServer()}/${ApiGatewaySSRPostfixV1}`;
};

export const ApiGatewayBasePathV2: (window: Window, platformService: PlatformService) => string = (
  window: Window,
  platformService: PlatformService
) => {
  if (platformService.isBrowser) {
    return `${window.location.origin}/${ApiGatewayClientPostfixV2}`;
  }

  return `${ConfigHelper.getApiGatewayURLForServer()}/${ApiGatewaySSRPostfixV2}`;
};
